import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '~redux/store';
import { Config, ConfigKey } from '~types/appsync.types';

export interface ConfigState {
  configKeys: ConfigKey[] | undefined;
}

const initialState: ConfigState = {
  configKeys: [],
};

export const configSlice = createSlice({
  initialState,
  name: 'config',
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setConfig: (state, action: PayloadAction<Config | null>) => {
      state.configKeys = action.payload?.configKeys;
    },
  },
});

export const { setConfig } = configSlice.actions;

export const getConfig = (state: RootState) => state.config;

export default configSlice.reducer;
